import React from "react";
import copiaAIIcon from "../../images/CopiaAi-Logo.png"

function WelcomeScreen({
    isLoading,
    authError,
    email,
    guid,
    startChat
}) {
    const styles = {
        welcomeContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '20px',
            textAlign: 'center'
        },
        robotContainer: {
            width: '80px',
            height: '80px',
            marginBottom: '20px',
            position: 'relative'
        },
        robotImage: {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: '12px'
        },
        startButton: {
            backgroundColor: '#CB2C84',
            borderColor: '#CB2C84'
        }
    };

    const customAnimations = `
    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    
    @keyframes fadeInUp {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }
    
    @keyframes bounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
    }
    
    @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
    }
    
    .welcome-title { animation: fadeIn 0.8s ease-in-out; }
    .welcome-description { animation: fadeIn 1s ease-in-out; }
    .welcome-button { animation: fadeIn 1.2s ease-in-out; }
    
    .robot-container {
        animation: bounce 2s infinite ease-in-out;
    }
    
    .robot-container:hover {
        animation: pulse 0.5s ease-in-out;
    }
    `;

    return (
        <>
            <style>{customAnimations}</style>

            <div style={styles.welcomeContainer}>
                <div style={styles.robotContainer} className="robot-container">
                    <img
                        src={copiaAIIcon}
                        alt="Copia Robot"
                        style={styles.robotImage}
                    />
                </div>
                <h4 className="welcome-title mb-3">Welcome to Copia247</h4>
                <p className="welcome-description text-muted mb-4">
                    I'm your AI assistant, ready to help answer your questions and provide information to
                    guide you through your experience.
                </p>

                {isLoading ? (
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : authError ? (
                    <div className="alert alert-danger" role="alert">
                        {authError}
                        <button
                            className="btn btn-danger mt-2"
                            onClick={startChat}
                        >
                            Try Again
                        </button>
                    </div>
                ) : (
                    <button
                        className="welcome-button btn btn-primary"
                        style={styles.startButton}
                        onClick={startChat}
                        disabled={!email || !guid}
                    >
                        Start Chatting
                    </button>
                )}
            </div>
        </>
    );
}

export default WelcomeScreen;